import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ObrasAdminGeralService } from "../services/obras-admin-geral.service";

@Injectable({
  providedIn: 'root'
})
export class ObrasAdminGeralResolver implements Resolve<boolean> {

  constructor(private service: ObrasAdminGeralService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}